import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { DatasetRowRead } from "@/types/dataset-rows";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";
import { useQuery } from "@tanstack/react-query";

export const useDatasetRow = (datasetRowId: number | null) => {
  const userToken = useUserToken();
  return useQuery<{
    success: boolean;
    dataset_row: DatasetRowRead;
    message?: string;
  }>(
    [ENDPOINTS.dataset_rows, userToken, datasetRowId],
    () => {
      if (!datasetRowId) return Promise.reject("Dataset row ID is required");
      return fetch(`${ENDPOINTS.dataset_rows}/${datasetRowId}`, {
        headers: authHeader(userToken),
      }).then(handleResponse);
    },
    {
      enabled: !!datasetRowId,
    },
  );
};
